"use client";

import { c as _c } from "react/compiler-runtime";
import { forwardRef, type InputHTMLAttributes } from "react";
type InputSize = "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
export type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "size"> & {
  size?: InputSize;
};
function mapSize(size: InputSize | undefined): "sm" | "lg" | undefined {
  if (size === "xs" || size === "sm") return "sm";
  if (size === "lg" || size === "xl" || size === "2xl") return "lg";
  return undefined;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(t0, ref) {
  const $ = _c(10);
  let className;
  let rest;
  let size;
  if ($[0] !== t0) {
    ({
      className,
      size,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = size;
  } else {
    className = $[1];
    rest = $[2];
    size = $[3];
  }
  let t1;
  if ($[4] !== size) {
    t1 = mapSize(size);
    $[4] = size;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const mapped = t1;
  const t2 = `form-control ${mapped ? `form-control-${mapped}` : ""} ${className ?? ""}`;
  let t3;
  if ($[6] !== ref || $[7] !== rest || $[8] !== t2) {
    t3 = <input ref={ref} className={t2} {...rest} />;
    $[6] = ref;
    $[7] = rest;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
});